module.exports = __webpack_public_path__ + "svg/search.svg?9a1c6c0b46bea0a07067eadabc312967";